module.exports = __webpack_public_path__ + "static/ranking-6c43fa84779804b220b893f57eb230f5.png";